/* ============================================================
   GENERATE V2 — tab Generate Workspace SEBENAR (admin, suis — 23 Okt 2026)
   ============================================================
   Rupa daripada prototaip /workspace-v4 (GenerateV2Komposer), DATA +
   PENGENDALI daripada objek `nyata` yang SAMA dengan composer v3.9
   (`komposerNyata` dalam App.jsx): produk · module + kunci pakej · avatar ·
   template GOYANG / sub-module · kuota · Generate. Laluan jana kad TIDAK
   ditulis semula — butang Generate memanggil `nyata.onGenerate`.

   Keputusan user (Fasa 1):
   • Tab All · Sell · Grow · Earn — Goal/Format/Pill setiap module daripada
     modal tetapan module (utils/generateV2Matlamat.js, lalai dalam kod).
   • Satu kad = satu module. "Create your own" (sedia ada) + "Blank Card"
     di sebelahnya, tab All sahaja.
   • ⚠️ BELUM BERSAMBUNG (sengaja): kotak arahan tambahan, Scene 1–5, Veo/Omni.
     Nilainya keadaan tempatan sahaja; tiada apa dihantar ke Generate.
   • ★ [2026-11-02] Blank Card SUDAH bersambung: butang Create memanggil
     nyata.onCiptaKadKosong → cipta kad kosong di My Agent (App.jsx). Veo/Omni
     disorok untuk kad kosong (GenerateV2Komposer).
   • Pelanggan tidak nampak rupa ini (useGenerateV2 — admin sahaja).

   ⛔ Jangan baca Firestore / tulis apa-apa di sini — semua melalui `nyata`.
   ============================================================ */

import { useState } from 'react';

import { Segmented } from '../design/ui';
import { useLang } from '../i18n';
import GenerateV2Komposer from './GenerateV2Komposer';
import { MODEL_CONTOH } from '../utils/generateV2';
import { GOAL_V2, FORMAT_V2, tapisGoal, bilSetUntukScene } from '../utils/generateV2Matlamat';

const SUSUN_V2 = [
    { id: 'asal', nama: 'Default order' },
    { id: 'az', nama: 'A–Z' },
];
const KAD_CIPTA = { id: '__cipta__', cipta: true, nama: 'Create your own', nota: 'Yours only' };
const KAD_KOSONG = { id: '__kosong__', kosong: true, nama: 'Blank Card', nota: 'No AI — fill it in yourself' };

/** Toggle admin lama ⇄ baru — kepala Workspace, sebelah pil bahasa (arahan user 23 Okt). */
export function GenerateV2Suis({ aktif, onTukar }) {
    return (
        <div title="Admin only — customers always see Classic" style={{ display: 'inline-flex', alignItems: 'center' }}>
            <Segmented
                value={aktif ? 'v2' : 'lama'}
                onChange={(v) => onTukar(v === 'v2')}
                options={[{ value: 'lama', label: 'Classic' }, { value: 'v2', label: 'v4' }]}
            />
        </div>
    );
}

export default function GenerateV2Nyata({ nyata }) {
    const { lang, t } = useLang();
    const [goalId, setGoalId] = useState('');
    const [formatId, setFormatId] = useState('');
    const [susunId, setSusunId] = useState('asal');
    const [kosongDipilih, setKosongDipilih] = useState(false);
    /* UI SAHAJA (belum bersambung) */
    const [bilBabak, setBilBabak] = useState(1);
    const [modelId, setModelId] = useState(MODEL_CONTOH[0].id);

    /* Ayat bawah nama — urutan SAMA seperti `notaFormula` dalam PromptComposerV39 (KEMBAR). */
    const nota = (f) => {
        const admin = lang === 'ms' ? f.notaMs : f.notaEn;
        if (admin != null) return admin;
        return f.kunciNota ? t(f.kunciNota) : (f.nota || '');
    };

    const semua = (nyata.formula || []).map((f) => ({
        id: f.id,
        nama: f.nama,
        nota: nota(f),
        poster: f.poster,
        video: f.video,
        tag: f.tag,
        pil: f.pilMedia || undefined,     // HOLD / DEMO / ZOOM
        hak: f.pil,                       // UPGRADE / TRIAL n/5
        goal: f.goal,
        format: f.format,
        terkunci: f.terkunci,
        scenes: f.scenes,
        kunciTip: f.kunciTip ? t(f.kunciTip) : undefined,
    }));
    const ditapis = tapisGoal(semua, goalId, formatId);
    const tersusun = susunId === 'az' ? [...ditapis].sort((a, b) => String(a.nama).localeCompare(String(b.nama))) : ditapis;
    const kad = [...(goalId ? [] : [KAD_CIPTA, KAD_KOSONG]), ...tersusun];
    const kiraGoal = Object.fromEntries(['', ...GOAL_V2.map((g) => g.id)].map((id) => [id, tapisGoal(semua, id, '').length]));

    const kadId = kosongDipilih ? KAD_KOSONG.id : (nyata.formulaPilihan || '');
    const dipilih = semua.find((k) => k.id === nyata.formulaPilihan);

    const pilihKad = (id, k) => {
        if (!id) {                                   // klik kad yang sama = batal
            if (kosongDipilih) setKosongDipilih(false);
            else nyata.onBatalFormula?.();
            return;
        }
        if (id === KAD_KOSONG.id) { setKosongDipilih(true); nyata.onBatalFormula?.(); return; }
        setKosongDipilih(false);
        nyata.onPilihFormula(id, k);                 // terkunci → /pricing (pengendali App.jsx)
    };

    const avatar = [...(nyata.avatarTetap || []), ...(nyata.avatarSimpanan || []).map((a) => ({ ...a, simpanan: true }))];

    const jana = kosongDipilih
        ? { label: 'Create blank card', boleh: true, tip: 'Creates an empty card in My Agent — you fill it in yourself', onClick: nyata.onCiptaKadKosong }
        : {
            label: nyata.labelJana, boleh: nyata.bolehJana, tip: nyata.tipJana, kuota: nyata.kuota,
            onClick: nyata.onGenerate, denyut: nyata.janaDenyut,
        };

    /* Scene (24 Okt): hanya scene yang admin benarkan untuk module dipilih. Pilihan lama yang tidak
       dibenarkan → scene pertama yang dibenarkan (dikira, bukan ditulis semula). RUPA SAHAJA. */
    const sceneBoleh = dipilih && !kosongDipilih ? dipilih.scenes : null;
    const bilBerkesan = sceneBoleh && !sceneBoleh.includes(bilBabak) ? sceneBoleh[0] : bilBabak;
    const bilSet = bilSetUntukScene(bilBerkesan);
    const notaScene = sceneBoleh
        ? `${bilSet === 3 ? '3 sets · up to 3 videos' : '1 set · 1 video'} of ${bilBerkesan * 8}s per product`
        : null;
    const sceneTipMati = dipilih
        ? (sceneBoleh?.length === 1 ? `This module is fixed at ${sceneBoleh[0]} scene${sceneBoleh[0] > 1 ? 's' : ''}` : 'Not available for this module')
        : undefined;

    const peta = kosongDipilih
        ? `Blank card · ${bilBerkesan} empty scene${bilBerkesan > 1 ? 's' : ''} — you write each one`
        : dipilih ? [dipilih.nama, dipilih.nota].filter(Boolean).join('  ·  ') : 'No module selected';

    return (
        <GenerateV2Komposer
            produk={(nyata.lampiran || []).map((p) => ({ kunci: p.id, nama: p.nama, img: p.img }))}
            onTambah={nyata.onTambah}
            onBuang={nyata.onBuang}
            matlamat={GOAL_V2}
            matlamatId={goalId}
            onMatlamat={setGoalId}
            kiraMatlamat={kiraGoal}
            format={FORMAT_V2}
            formatId={formatId}
            onFormat={setFormatId}
            susun={SUSUN_V2}
            susunId={susunId}
            onSusun={setSusunId}
            styles={kad}
            styleId={kadId}
            onStyle={pilihKad}
            onCipta={nyata.onCiptaFormula}
            onTetapan={nyata.onTetapanFormula}
            onCiptaModule={nyata.onCiptaModule}
            tambahan={nyata.tambahan}
            kosongMesej={goalId ? 'No modules in this tab yet' : undefined}
            bilBabak={bilBerkesan}
            onBabak={setBilBabak}
            sceneBoleh={sceneBoleh}
            sceneTipMati={sceneTipMati}
            notaScene={notaScene}
            model={MODEL_CONTOH}
            modelId={modelId}
            onModel={setModelId}
            avatar={avatar}
            avatarId={nyata.avatarPilihan}
            onAvatar={nyata.onPilihAvatar}
            avatarSorok={!!nyata.avatarMati}
            avatarSorokNota={nyata.avatarMatiNota}
            onAvatarBaharu={nyata.onAvatarBaharu}
            onSuntingAvatar={nyata.onSuntingAvatar}
            slotAvatar={nyata.slotAvatar}
            peta={peta}
            jana={jana}
            janaRef={nyata.janaRef}
        />
    );
}
